import { PropsWithChildren } from 'react';

import { twMerge } from '@/core/tamagoshiTailwind/util/twMerge';

interface SectionProps extends PropsWithChildren {
  withBorder?: boolean;
  className?: string;
}

export const Section = ({ children, withBorder, className }: SectionProps) => {
  return (
    <div
      className={twMerge(
        'px-m empty:hidden',
        withBorder && 'mx-m rounded-card border border-foundation-primary py-m',
        className,
      )}
    >
      {children}
    </div>
  );
};
